export default __webpack_public_path__ + "static/media/dashboard-initiated-history-icon.02769345.svg";